import { grey } from '@material-ui/core/colors';

export default {
  colorPrimary: {
    backgroundColor: grey[200],
  },
};
